import React from 'react';
import classnames from '../../core/utils/classnames.tsx';

const TooltipContentRoot = ({ className, ...props }: React.ComponentPropsWithRef<'div'>) => {
    return (
        <div
            className={classnames(
                'flex flex-col bg-surface-black text-content-white py-1.5 px-3 rounded shadow-lg text-sm',
                className
            )}
            {...props}
        />
    );
};

const TooltipContentTitle = ({ className, ...props }: React.ComponentPropsWithRef<'div'>) => {
    return <div className={classnames('text-content-white opacity-80 text-sm', className)} {...props} />;
};

const TooltipContentRow = ({ className, ...props }: React.ComponentPropsWithRef<'div'>) => {
    return (
        <div
            className={classnames('text-content-white flex gap-2 items-center justify-between text-sm', className)}
            {...props}
        />
    );
};

export default Object.assign(TooltipContentRoot, {
    Title: TooltipContentTitle,
    Row: TooltipContentRow,
});
